<ng-template #walletBindingTpl let-row>
  <div class="gw-flex gw-flex-col gw-gap-1">
    <ng-container
      *ngIf="walletBindingScope(row) as scope; else walletNoBindingTpl"
    >
      <span
        [tuiStatus]="scope === 'standalone' ? '#2563EB' : '#7C3AED'"
        class="gw-text-xs gw-self-start"
      >
        {{ scope | integrationScope | translate }}
      </span>

      <ng-container *ngIf="row.pool as pool">
        <span class="gw-text-xs gw-text-text-secondary">
          {{
            'features.wallets.binding.poolLine'
              | translate : {id: pool.id, label: pool.label}
          }}
        </span>
        <span class="gw-text-xs gw-text-text-secondary">
          {{
            'features.wallets.binding.integrationLine'
              | translate : {id: pool.integration.id}
          }}
          · {{ pool.integration.provider | provider }}
        </span>
      </ng-container>

      <ng-container *ngIf="!row.pool && row.integration as integration">
        <span class="gw-text-xs gw-text-text-secondary">
          {{
            'features.wallets.binding.integrationLine'
              | translate : {id: integration.id}
          }}
          · {{ integration.provider | provider }}
        </span>
        <span
          *ngIf="integration.description"
          class="gw-text-xs gw-text-text-secondary gw-italic"
        >
          {{ integration.description }}
        </span>
      </ng-container>
    </ng-container>

    <ng-template #walletNoBindingTpl>
      <span class="gw-text-sm gw-text-text-secondary">—</span>
    </ng-template>
  </div>
</ng-template>

<ng-template #walletLabelTpl let-row>
  <span class="gw-text-sm gw-text-text-primary">
    {{ row.label || '—' }}
  </span>
</ng-template>

<ng-template #walletAccountTpl let-row>
  <span class="gw-text-sm gw-text-text-secondary">
    <ng-container *ngIf="row.agency || row.account; else walletNoAccountTpl">
      <span *ngIf="row.agency"
        >{{ row.agency }}<span *ngIf="row.account"> / </span></span
      >
      <span *ngIf="row.account">{{ row.account }}</span>
    </ng-container>
    <ng-template #walletNoAccountTpl>—</ng-template>
  </span>
</ng-template>

<ng-template #walletStatusTpl let-row>
  <span
    *ngIf="row.isPrimary"
    class="gw-inline-flex gw-items-center gw-rounded-full gw-bg-accent-primary/10 gw-px-2 gw-py-0.5 gw-text-xs gw-font-medium gw-text-accent-primary"
  >
    {{ 'features.wallets.isPrimary' | translate }}
  </span>
  <span *ngIf="!row.isPrimary" class="gw-text-sm gw-text-text-secondary"
    >—</span
  >
</ng-template>

<ng-container *ngIf="!disableContentPage; else contentWithoutWrapper">
  <gatewee-content-page
    [breadcrumb]="
      breadcrumb.length
        ? breadcrumb
        : [
            {label: titlePath | translate, path: '/recipients'},
            {label: title | translate}
          ]
    "
    [title]="title | translate"
  >
    <div page-body>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </gatewee-content-page>
</ng-container>

<ng-template #contentWithoutWrapper>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</ng-template>

<ng-template #contentTemplate>
  <div class="gw-mb-6 gw-flex gw-items-center gw-justify-end gw-gap-3">
    <gatewee-button
      variant="primary"
      size="m"
      iconName="@phi.plus"
      [title]="'features.wallets.create.title' | translate"
      (clicked)="openCreateWalletDialog()"
    ></gatewee-button>
  </div>

  <div
    *ngIf="loadingWallets"
    class="gw-flex gw-justify-center gw-items-center gw-py-16"
  >
    <p class="gw-text-text-secondary gw-text-base">
      {{ 'common.loading' | translate }}...
    </p>
  </div>

  <ng-container *ngIf="!loadingWallets">
    <div
      *ngIf="wallets.length; else noWalletsTpl"
      class="gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-overflow-hidden"
    >
      <gatewee-table-v2
        *ngIf="walletColumns.length"
        [data]="wallets"
        [columns]="walletColumns"
        [page]="1"
        [pageSize]="wallets.length || 10"
        [total]="wallets.length"
        [showSettings]="false"
        [tableId]="'gatewee-wallets-table'"
        (outClick)="onWalletActionClicked($event)"
      ></gatewee-table-v2>
    </div>

    <ng-template #noWalletsTpl>
      <p class="gw-text-sm gw-text-text-secondary gw-m-0">
        {{ 'features.wallets.noWallets' | translate }}
      </p>
    </ng-template>
  </ng-container>
</ng-template>
